const { ApiService, ApiRoutes, RequestType } = require("../helpers/common"); 

class UserService {
    static async login(user) {
        return await ApiService.sendRequest(RequestType.POST, ApiRoutes.loginURL, user);
    }

    static async register(user) {
        return await ApiService.sendRequest(RequestType.POST, ApiRoutes.registerURL, user);
    }

    static async getUser(userId) {
        return await ApiService.sendRequest(RequestType.POST, ApiRoutes.getUserURL, userId);
    }

    static async getProfile(username) {
        return await ApiService.sendRequest(RequestType.POST, ApiRoutes.getProfileURL, { username });
    }

    static async getProfileSettings({ userId }) {
        return await ApiService.sendRequest(RequestType.POST, ApiRoutes.getProfileSettingsURL, { userId });
    }

    static async setProfileSettings({ user }) {
        return await ApiService.sendRequest(RequestType.POST, ApiRoutes.setProfileSettingsURL, { user });
    }
}

export default UserService;